module.exports = __webpack_public_path__ + "img/post-thumbnail.cc834eaa.jpg";